import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, Zap, Wrench, Award, CheckCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import displayVideo from "@/assets/bfc-display-video.mp4";
import machineVideo from "@/assets/bfc-machine-video.mp4";
import bfcLogo from "@/assets/bfc-logo.jpg";

export const BFC = () => {
  const { t } = useLanguage();

  const benefits = [
    { icon: <Shield className="w-8 h-8" />, title: t("bfc", "benefit1Title"), description: t("bfc", "benefit1Desc") },
    { icon: <Zap className="w-8 h-8" />, title: t("bfc", "benefit2Title"), description: t("bfc", "benefit2Desc") },
    { icon: <Wrench className="w-8 h-8" />, title: t("bfc", "benefit3Title"), description: t("bfc", "benefit3Desc") },
    { icon: <Award className="w-8 h-8" />, title: t("bfc", "benefit4Title"), description: t("bfc", "benefit4Desc") },
  ];

  return <section id="maquinas-bfc" className="py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <img src={bfcLogo} alt="BFC Coffee Machines España" className="h-24 object-contain" />
          </div>
          <div className="inline-block px-4 py-2 bg-gold/20 rounded-full border border-gold/40 mb-4">
            <span className="text-foreground text-sm font-medium">{t("bfc", "badge")}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">{t("bfc", "title")}</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">{t("bfc", "subtitle")}</p>
          <div className="w-24 h-1 bg-gold mx-auto mt-6"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <video className="rounded-2xl overflow-hidden shadow-2xl h-96 w-full object-cover" autoPlay loop muted playsInline>
              <source src={displayVideo} type="video/mp4" />
            </video>
            <video className="rounded-2xl overflow-hidden shadow-2xl h-96 w-full object-cover" autoPlay loop muted playsInline>
              <source src={machineVideo} type="video/mp4" />
            </video>
          </div>
          <div>
            <h3 className="text-3xl font-bold mb-6">{t("bfc", "whyBfc")}</h3>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">{t("bfc", "whyBfcP1")}</p>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">{t("bfc", "whyBfcP2")}</p>
            <div className="grid sm:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3">
                  <div className="text-gold flex-shrink-0">{benefit.icon}</div>
                  <div>
                    <h4 className="font-bold mb-1">{benefit.title}</h4>
                    <p className="text-sm text-muted-foreground">{benefit.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <Card className="p-12 bg-card border-2 border-border">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold mb-6 text-center">{t("bfc", "coffeeManTitle")}</h3>
            <p className="text-lg text-muted-foreground mb-8 text-center">{t("bfc", "coffeeManDesc")}</p>
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <CheckCircle className="w-10 h-10 text-gold mx-auto mb-3" />
                <h4 className="font-bold mb-2">{t("bfc", "asesoriaPersonalizada")}</h4>
                <p className="text-sm text-muted-foreground">{t("bfc", "asesoriaPersonalizadaDesc")}</p>
              </div>
              <div className="text-center">
                <CheckCircle className="w-10 h-10 text-gold mx-auto mb-3" />
                <h4 className="font-bold mb-2">{t("bfc", "formacionCompleta")}</h4>
                <p className="text-sm text-muted-foreground">{t("bfc", "formacionCompletaDesc")}</p>
              </div>
              <div className="text-center">
                <CheckCircle className="w-10 h-10 text-gold mx-auto mb-3" />
                <h4 className="font-bold mb-2">{t("bfc", "soporteContinuo")}</h4>
                <p className="text-sm text-muted-foreground">{t("bfc", "soporteContinuoDesc")}</p>
              </div>
            </div>
            <div className="text-center">
              <Button variant="premium" size="lg" asChild>
                <a href="#contacto">{t("bfc", "consultarMaquinas")}</a>
              </Button>
            </div>
          </div>
        </Card>

        <div className="mt-16 bg-gradient-to-r from-espresso to-warmBrown rounded-2xl p-8 text-center">
          <p className="text-xl text-cream italic max-w-3xl mx-auto">{t("bfc", "quote")}</p>
        </div>
      </div>
    </section>;
};
